var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgInterrogation(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 50,
    height: 51,
    viewBox: "0 0 50 51",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1220",
    "data-name": "Group 1220",
    transform: "translate(-1027 -22383)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_268",
    "data-name": "Ellipse 268",
    cx: 25,
    cy: 25.5,
    rx: 25,
    ry: 25.5,
    transform: "translate(1027 22383)",
    fill: "#36f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "question_mark_FILL0_wght400_GRAD0_opsz48",
    d: "M280.843,238.228a11.847,11.847,0,0,1,.719-4.576,10.628,10.628,0,0,1,2.55-3.138,18.546,18.546,0,0,0,2.811-3.073,5.225,5.225,0,0,0,.981-3.029,4.435,4.435,0,0,0-1.307-3.269,4.949,4.949,0,0,0-3.661-1.308,4.578,4.578,0,0,0-3.487,1.286,8.645,8.645,0,0,0-1.787,2.68L274,222.189a9.953,9.953,0,0,1,3.247-4.38,10.206,10.206,0,0,1,12.4.61,8.415,8.415,0,0,1,1.46,9.61,14.4,14.4,0,0,1-2.855,3.574,11.153,11.153,0,0,0-2.571,3.138,10.664,10.664,0,0,0-.479,3.487Zm2.092,10.9a3.05,3.05,0,1,1,2.157-.893A2.94,2.94,0,0,1,282.935,249.123Z",
    transform: "translate(769 22175.938)",
    fill: "#fff"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInterrogation);
export default __webpack_public_path__ + "static/media/interrogation.9e6276e2ce5cf2570ff073b495ac2854.svg";
export { ForwardRef as ReactComponent };